<template>
  <div id="ListRegisterRequests">
    <loading v-if="loadingRender"></loading>
    <panel
      Title="گزارش درخواست های عضویت"
      Des="از طریق این فرم می توانید لیست درخواست های عضویت را مشاهده نمایید"
      :IsBtnBack="true"
      ClassCustom="bg-dark-Custom text-right mt-2"
    ></panel>

    <div class="row">
      <div class="col-12">
        <net-pa-card>
          <template slot="header">
            <h6 class="text-right">
              <i class="fas fa-user-plus"></i>
              لیست درخواست های عضویت
            </h6>
          </template>
          <template slot="content">
        <div class="list-register-requests-filters">
          <div class="list-register-requests-field">
            <label class="list-register-requests-label">از تاریخ</label>
            <date-picker
              :editable="true"
              :auto-submit="true"
              :max="TarikhTa"
              color="#287db4"
              v-model="TarikhAz"
            >
            </date-picker>
            <input
              type="text"
              tabindex="-1"
              class="d-none InputText"
              style="direction: ltr"
            />
          </div>
          <div class="list-register-requests-field">
            <label class="list-register-requests-label">تا تاریخ</label>
            <date-picker
              :editable="true"
              :auto-submit="true"
              :min="TarikhAz"
              color="#287db4"
              v-model="TarikhTa"
            >
            </date-picker>
            <input
              type="text"
              tabindex="-1"
              class="d-none InputText"
              style="direction: ltr"
            />
          </div>
          <div class="list-register-requests-field list-register-requests-action">
            <span
              class="list-register-requests-label list-register-requests-label--spacer"
              aria-hidden="true"
              >&nbsp;</span
            >
            <button
              type="button"
              class="btn btn-success list-register-requests-search-btn"
              @click="Search"
            >
              <i class="fa fa-search ml-1" aria-hidden="true"></i>
              جستجو
            </button>
          </div>
        </div>

        <div
          v-if="$store.state.renderComponentGrid"
          class="list-register-requests-results"
        >
          <div class="list-register-requests-cards" dir="rtl">
            <p v-if="!rows.length" class="list-register-requests-cards__empty">
              موردی برای نمایش وجود ندارد
            </p>
            <template v-else>
            <div class="list-register-requests-cards__toolbar">
              <input
                v-model="cardSearch"
                type="search"
                class="form-control list-register-requests-cards__search"
                placeholder=" جستجو"
                aria-label="جستجو در درخواست‌ها"
              />
            </div>
            <p
              v-if="filteredCardRows.length === 0"
              class="list-register-requests-cards__empty"
            >
              اطلاعاتی یافت نشد
            </p>
            <div v-else class="list-register-requests-cards__list">
              <article
                v-for="(row, index) in pagedCardRows"
                :key="(row.id || 'row') + '-' + index"
                class="list-register-requests-card"
              >
                <div class="list-register-requests-card__header">
                  <strong class="list-register-requests-card__name">{{
                    row.nameFamily
                  }}</strong>
                  <span
                    v-if="row.grpName"
                    class="list-register-requests-card__badge"
                    >{{ row.grpName }}</span
                  >
                </div>
                <div class="list-register-requests-card__fields">
                  <div v-if="row.codeMeli" class="list-register-requests-card__field">
                    <span>کد ملی</span>
                    <strong dir="ltr">{{ row.codeMeli }}</strong>
                  </div>
                  <div v-if="row.mobile" class="list-register-requests-card__field">
                    <span>شماره همراه</span>
                    <strong dir="ltr">{{ row.mobile }}</strong>
                  </div>
                  <div v-if="row.tarixOzv" class="list-register-requests-card__field">
                    <span>تاریخ درخواست</span>
                    <strong>{{ row.tarixOzv }}</strong>
                  </div>
                </div>
                <div
                  v-if="expandedCardId === row.id"
                  class="list-register-requests-card__fields list-register-requests-card__fields--more"
                >
                  <div v-if="row.perNo" class="list-register-requests-card__field">
                    <span>شماره پرسنلی</span>
                    <strong dir="ltr">{{ row.perNo }}</strong>
                  </div>
                  <div v-if="row.pedar" class="list-register-requests-card__field">
                    <span>نام پدر</span>
                    <strong>{{ row.pedar }}</strong>
                  </div>
                  <div
                    v-if="row.desMoaref"
                    class="list-register-requests-card__field"
                  >
                    <span>معرف</span>
                    <strong>{{ row.desMoaref }}</strong>
                  </div>
                  <div
                    v-if="row.desState"
                    class="list-register-requests-card__field"
                  >
                    <span>توضیحات</span>
                    <strong>{{ row.desState }}</strong>
                  </div>
                </div>
                <div class="list-register-requests-card__actions">
                  <button
                    type="button"
                    class="list-register-requests-row-btn list-register-requests-row-btn--details"
                    @click="toggleCardDetails(row.id)"
                  >
                    <i
                      class="fas"
                      :class="
                        expandedCardId === row.id
                          ? 'fa-chevron-up'
                          : 'fa-chevron-down'
                      "
                      aria-hidden="true"
                    ></i>
                    <span>{{
                      expandedCardId === row.id ? "بستن جزئیات" : "جزئیات"
                    }}</span>
                  </button>
                  <div
                    v-if="$session.get('CustCode') == 932"
                    class="list-register-requests-row-actions"
                  >
                    <div class="dropdown">
                      <button
                        :id="'reg-attach-card-' + row.id"
                        class="list-register-requests-row-btn list-register-requests-row-btn--attach dropdown-toggle"
                        type="button"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                        title="مشاهده پیوست‌ها"
                      >
                        <i class="fas fa-paperclip" aria-hidden="true"></i>
                        <span>پیوست‌ها</span>
                      </button>
                      <div
                        class="dropdown-menu list-register-requests-attach-menu"
                        :aria-labelledby="'reg-attach-card-' + row.id"
                      >
                        <a
                          class="dropdown-item"
                          href="javascript:;"
                          @click="
                            GetItemCardMeli(row.id);
                            $ResetTimer();
                          "
                        >
                          <i class="far fa-id-card" aria-hidden="true"></i>
                          تصویر روی کارت ملی
                        </a>
                        <a
                          class="dropdown-item"
                          href="javascript:;"
                          @click="
                            GetItemShenasname(row.id);
                            $ResetTimer();
                          "
                        >
                          <i class="far fa-file-alt" aria-hidden="true"></i>
                          صفحه اول شناسنامه
                        </a>
                        <a
                          class="dropdown-item"
                          href="javascript:;"
                          @click="
                            GetItemHokm(row.id);
                            $ResetTimer();
                          "
                        >
                          <i class="fas fa-file-invoice" aria-hidden="true"></i>
                          حکم کارگزینی / مستمری
                        </a>
                        <a
                          class="dropdown-item"
                          href="javascript:;"
                          @click="
                            Get3File(row.id);
                            $ResetTimer();
                          "
                        >
                          <i class="fas fa-file-archive" aria-hidden="true"></i>
                          دانلود هر سه فایل (ZIP)
                        </a>
                      </div>
                    </div>
                    <button
                      class="list-register-requests-row-btn list-register-requests-row-btn--edit"
                      type="button"
                      title="نیاز به اصلاح"
                      @click="openModal(row.id)"
                      data-toggle="modal"
                      data-target="#Modal-ListRequset"
                    >
                      <i class="fas fa-pen" aria-hidden="true"></i>
                      <span>نیاز به اصلاح</span>
                    </button>
                    <button
                      class="list-register-requests-row-btn list-register-requests-row-btn--approve"
                      type="button"
                      title="تایید شد"
                      @click="okState({ row: row })"
                    >
                      <i class="fas fa-check" aria-hidden="true"></i>
                      <span>تایید شد</span>
                    </button>
                    <button
                      v-if="row.stateId == 181070525"
                      class="list-register-requests-row-btn list-register-requests-row-btn--receipt"
                      type="button"
                      title="دانلود فیش"
                      @click="
                        GetFish(row.id);
                        $ResetTimer();
                      "
                    >
                      <i class="fas fa-download" aria-hidden="true"></i>
                      <span>دانلود فیش</span>
                    </button>
                    <button
                      type="button"
                      class="list-register-requests-row-btn list-register-requests-row-btn--delete"
                      title="حذف درخواست"
                      @click="removeRequest({ row: row })"
                    >
                      <i class="fas fa-trash-alt" aria-hidden="true"></i>
                      <span class="sr-only">حذف درخواست</span>
                    </button>
                  </div>
                  <div
                    v-if="$session.get('CustCode') == 8002"
                    class="list-register-requests-row-actions"
                  >
                    <button
                      class="list-register-requests-row-btn list-register-requests-row-btn--sms"
                      type="button"
                      title="ارسال پیامک"
                      @click="
                        GetFish(row.id);
                        $ResetTimer();
                      "
                    >
                      <i class="fas fa-sms" aria-hidden="true"></i>
                      <span>ارسال پیامک</span>
                    </button>
                  </div>
                </div>
              </article>
            </div>
            <div
              v-if="filteredCardRows.length > cardPerPage"
              class="list-register-requests-cards__pager"
            >
              <button
                type="button"
                class="list-register-requests-cards__pager-btn"
                :disabled="cardPage <= 1"
                @click="cardPage = cardPage - 1"
              >
                قبلی
              </button>
              <span class="list-register-requests-cards__pager-info">
                صفحه {{ cardPage }} از {{ cardPageCount }}
              </span>
              <button
                type="button"
                class="list-register-requests-cards__pager-btn"
                :disabled="cardPage >= cardPageCount"
                @click="cardPage = cardPage + 1"
              >
                بعدی
              </button>
            </div>
            </template>
          </div>
          <div class="list-register-requests-table-view">
            <vue-bootstrap4-table
              :rows="rows"
              :columns="columns"
              :config="config"
              :classes="classes"
            >
              <template slot="sort-asc-icon">
                <i class="fa fa-sort-up"></i>
              </template>
              <template slot="sort-desc-icon">
                <i class="fa fa-sort-down"></i>
              </template>
              <template slot="no-sort-icon">
                <i class="fa fa-sort"></i>
              </template>
              <template slot="empty-results">
                <p class="text-right">اطلاعاتی یافت نشد</p>
              </template>
              <template slot="Action" slot-scope="props">
                <div
                  v-if="$session.get('CustCode') == 932"
                  class="list-register-requests-row-actions"
                >
                  <div class="dropdown">
                    <button
                      :id="'reg-attach-' + props.row.id"
                      class="list-register-requests-row-btn list-register-requests-row-btn--attach dropdown-toggle"
                      type="button"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      title="مشاهده پیوست‌ها"
                    >
                      <i class="fas fa-paperclip" aria-hidden="true"></i>
                      <span>پیوست‌ها</span>
                    </button>
                    <div
                      class="dropdown-menu list-register-requests-attach-menu"
                      :aria-labelledby="'reg-attach-' + props.row.id"
                    >
                      <a
                        class="dropdown-item"
                        href="javascript:;"
                        @click="
                          GetItemCardMeli(props.row.id);
                          $ResetTimer();
                        "
                      >
                        <i class="far fa-id-card" aria-hidden="true"></i>
                        تصویر روی کارت ملی
                      </a>
                      <a
                        class="dropdown-item"
                        href="javascript:;"
                        @click="
                          GetItemShenasname(props.row.id);
                          $ResetTimer();
                        "
                      >
                        <i class="far fa-file-alt" aria-hidden="true"></i>
                        صفحه اول شناسنامه
                      </a>
                      <a
                        class="dropdown-item"
                        href="javascript:;"
                        @click="
                          GetItemHokm(props.row.id);
                          $ResetTimer();
                        "
                      >
                        <i class="fas fa-file-invoice" aria-hidden="true"></i>
                        حکم کارگزینی / مستمری
                      </a>
                      <a
                        class="dropdown-item"
                        href="javascript:;"
                        @click="
                          Get3File(props.row.id);
                          $ResetTimer();
                        "
                      >
                        <i class="fas fa-file-archive" aria-hidden="true"></i>
                        دانلود هر سه فایل (ZIP)
                      </a>
                    </div>
                  </div>
                  <button
                    class="list-register-requests-row-btn list-register-requests-row-btn--edit"
                    type="button"
                    title="نیاز به اصلاح"
                    @click="openModal(props.row.id)"
                    data-toggle="modal"
                    data-target="#Modal-ListRequset"
                  >
                    <i class="fas fa-pen" aria-hidden="true"></i>
                    <span>نیاز به اصلاح</span>
                  </button>
                  <button
                    class="list-register-requests-row-btn list-register-requests-row-btn--approve"
                    type="button"
                    title="تایید شد"
                    @click="okState(props)"
                  >
                    <i class="fas fa-check" aria-hidden="true"></i>
                    <span>تایید شد</span>
                  </button>
                  <button
                    v-if="props.row.stateId == 181070525"
                    class="list-register-requests-row-btn list-register-requests-row-btn--receipt"
                    type="button"
                    title="دانلود فیش"
                    @click="
                      GetFish(props.row.id);
                      $ResetTimer();
                    "
                  >
                    <i class="fas fa-download" aria-hidden="true"></i>
                    <span>دانلود فیش</span>
                  </button>
                  <button
                    type="button"
                    class="list-register-requests-row-btn list-register-requests-row-btn--delete"
                    title="حذف درخواست"
                    @click="removeRequest(props)"
                  >
                    <i class="fas fa-trash-alt" aria-hidden="true"></i>
                    <span class="sr-only">حذف درخواست</span>
                  </button>
                </div>
                <div
                  v-if="$session.get('CustCode') == 8002"
                  class="list-register-requests-row-actions"
                >
                  <button
                    class="list-register-requests-row-btn list-register-requests-row-btn--sms"
                    type="button"
                    title="ارسال پیامک"
                    @click="
                      GetFish(props.row.id);
                      $ResetTimer();
                    "
                  >
                    <i class="fas fa-sms" aria-hidden="true"></i>
                    <span>ارسال پیامک</span>
                  </button>
                </div>
              </template>
            </vue-bootstrap4-table>
          </div>
        </div>
          </template>
        </net-pa-card>
      </div>
    </div>

    <div
      class="btn Pointer btn-outline-info d-none"
      @click="openModal"
      data-toggle="modal"
      data-target="#Modal-ListRequset"
    >
      <i class="fas fa-list ml-2"></i>
    </div>
    <!-- Modal -->
    <div
      class="modal fade"
      id="Modal-ListRequset"
      data-backdrop="static"
      data-keyboard="false"
      tabindex="-1"
      aria-labelledby="Modal-ListRequsetLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header bg-info">
            <h5 class="modal-title text-dark" id="Modal-ListRequsetLabel">
              شرح اصلاح
            </h5>
          </div>
          <div class="modal-body text-right">
            <div class="row px-3">
              <div class="col-12 col-md-12 mt-2 p-2">
                <div class="w-100 border bnp-rounded Netpa-Shadow p-2">
                  <div class="row">
                    <div class="col-12 text-right">
                      <span class="text-secondary">شرح اصلاحات : </span>
                      <textarea
                        type="text"
                        class="form-control text-center"
                        dir="rtl"
                        v-model="DesState"
                      ></textarea>
                    </div>
                    <div class="col-12 mt-1 text-center">
                      <button
                        @click="edtitState(rowIdSelected)"
                        class="btn NetPa-btn btn-primary"
                      >
                        ثبت تغییرات
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              @click="$router.go(-1)"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              انصراف
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Panel from "../Tools/NetPa/Panel.vue";
import NetPaCard from "../Tools/NetPa/NetPaCard.vue";
import VueBootstrap4Table from "vue-bootstrap4-table";
import loading from "../Tools/NetPa/Loading.vue";

export default {
  data() {
    return {
      TarikhAz: "",
      TarikhTa: "",
      rowIdSelected: 0,
      DataAxiosRow: {
        ArryfildValue: "",
        Method: "Post",
        Action: "SelEftetahHesab",
        Token: this.$session.get("TokenNetPa"),
      },
      rows: [],
      columns: [
        {
          label: "id",
          name: "id",
          visibility: false,
        },
        {
          label: "نام و نام خانوادگی",
          name: "nameFamily",
        },
        {
          label: "کد ملی",
          name: "codeMeli",
        },
        {
          label: "شماره پرسنلی",
          name: "perNo",
        },
        {
          label: "نام پدر ",
          name: "pedar",
        },
        {
          label: "شماره همراه ",
          name: "mobile",
        },
        {
          label: "تاریخ درخواست",
          name: "tarixOzv",
        },
        {
          label: "وضعیت",
          name: "grpName",
        },
        {
          label: "StateId",
          name: "stateId",
          visibility: false,
        },
        {
          label: "توضیحات",
          name: "desState",
        },
        {
          label: "معرف",
          name: "desMoaref",
        },
        {
          label: "عملیات",
          name: "Action",
          sort: false,
          column_classes: "list-register-requests-action-cell",
        },
      ],
      config: {
        pagination: false,
        pagination_info: false,
        per_page_options: [10, 20, 30, 50, 100],
        show_refresh_button: false,
        show_reset_button: false,
        checkbox_rows: false,
        rows_selectable: true,
        card_title: "",
        card_mode: false,
        global_search: {
          placeholder: " جستجو",
          visibility: true,
          case_sensitive: false,
          showClearButton: true,
          searchOnPressEnter: false,
          searchDebounceRate: 1000,
        },
      },
      classes: {
        table: "table-bordered table-striped table-sm ",
      },
      loadingRender: false,
      cardSearch: "",
      cardPage: 1,
      cardPerPage: 10,
      expandedCardId: null,
      Files: [],
      DataAxios_ModirTaeed: {
        ArryfildValue: "",
        Method: "Post",
        Action: "NewtblAza/ModirTaeed",
        Token: "",
      },
      DataAxios_edtitState: {
        ArryfildValue: "",
        Method: "Post",
        Action: "NewtblAza/UpdateDesState",
        Token: "",
      },
      DesState: "",
    };
  },
  computed: {
    filteredCardRows() {
      const q = (this.cardSearch || "").trim().toLowerCase();
      if (!q) return this.rows;
      return this.rows.filter((row) => {
        const hay = [
          row.nameFamily,
          row.codeMeli,
          row.perNo,
          row.pedar,
          row.mobile,
          row.tarixOzv,
          row.grpName,
          row.desState,
          row.desMoaref,
        ]
          .filter((v) => v != null && v !== "")
          .join(" ")
          .toLowerCase();
        return hay.includes(q);
      });
    },
    pagedCardRows() {
      const start = (this.cardPage - 1) * this.cardPerPage;
      return this.filteredCardRows.slice(start, start + this.cardPerPage);
    },
    cardPageCount() {
      return Math.max(
        1,
        Math.ceil(this.filteredCardRows.length / this.cardPerPage),
      );
    },
  },
  watch: {
    rows() {
      this.cardPage = 1;
      this.expandedCardId = null;
    },
    cardSearch() {
      this.cardPage = 1;
    },
  },
  components: {
    Panel,
    NetPaCard,
    VueBootstrap4Table,
    loading,
  },
  methods: {
    toggleCardDetails(id) {
      this.expandedCardId = this.expandedCardId === id ? null : id;
    },
    Search() {
      this.$ResetTimer();
      this.GetData();
    },
    openModal(data) {
      $("#Modal-ListRequset").modal("show");
      this.rowIdSelected = data;
    },
    closeModal() {
      $("#Modal-ListRequset").modal("hide");
    },
    CancelDelete() {},
    IsModirTaeed(node) {
      this.loadingRender = true;
      const formData = new FormData();
      formData.append("id", node.row.id);
      this.DataAxios_ModirTaeed.ArryfildValue = formData;
      //#region ثبت عضو و تعهد
      var formdata = new FormData();
      formdata.append("id", node.row.id);
      formdata.append("noeId", Number(JSON.parse(this.$GetNoeIdPishFarz())));
      var DataAxios_AzaForEftetahHesab = {
        ArryfildValue: formdata,
        Method: "Post",
        Action: "AzaForEftetahHesab",
        Token: "",
      };
      this.$PostFormData(DataAxios_AzaForEftetahHesab).then((data) => {});
      //#endregion
      this.$PostFormData(this.DataAxios_ModirTaeed).then(() => {
        this.$mySweetDefaultTost(
          "تایید موفق",
          " تایید درخواست عضویت با موفقیت انجام شد",
          "success",
          4000,
        );
        this.loadingRender = false;
        this.$store.state.renderComponentGrid = false;
        this.$nextTick(() => {
          this.$store.state.renderComponentGrid = true;
        });
      });
    },
    okState(item) {
      this.$SweetQustion(
        "تایید درخواست عضویت",
        "آیا از تایید درخواست عضویت اطمینان دارید؟",
        "info",
        "تایید",
        "انصراف",
        item,
        this.IsModirTaeed,
        this.CancelDelete,
      );
    },
    edtitState(rowIdSelected) {
      this.loadingRender = true;
      const formData = new FormData();
      formData.append("id", rowIdSelected);
      formData.append("DesState", this.DesState);
      this.DataAxios_edtitState.ArryfildValue = formData;

      this.$PostFormData(this.DataAxios_edtitState).then(() => {
        this.$mySweetDefaultTost(
          "اصلاح موفق",
          " اصلاح درخواست عضویت با موفقیت انجام شد",
          "success",
          4000,
        );

        this.loadingRender = false;
        this.$store.state.renderComponentGrid = false;
        this.$nextTick(() => {
          this.$store.state.renderComponentGrid = true;
          this.closeModal();
        });
      });
    },
    GetData() {
      this.loadingRender = true;
      const formData = new FormData();
      formData.append(
        "wwwtblShobeId",
        this.$session.get("UserInfoNetPa").wwwtblShobeId,
      );
      formData.append("AzTarix", this.TarikhAz == null ? "" : this.TarikhAz);
      formData.append("TaTarix", this.TarikhTa == null ? "" : this.TarikhTa);
      this.DataAxiosRow.ArryfildValue = formData;
      // console.log(this.DataAxiosRow.ArryfildValue);

      this.$PostFormData(this.DataAxiosRow).then((data) => {
        if (data.length) {
          let info;
          let list = [];
          if (data.length > 10) {
            this.config.pagination = true;
          } else {
            this.config.pagination = false;
          }
          for (let index = 0; index < data.length; index++) {
            info = data[index];
            list.push(info);
          }
          this.rows = list;
          this.loadingRender = false;
          this.$store.state.renderComponentGrid = false;
          this.$nextTick(() => {
            this.$store.state.renderComponentGrid = true;
          });
        } else {
          this.$mySweetDefaultTost(
            "عدم وجود اطلاعات",
            "درخواست عضویت یافت نشد ، فیلتر جستجوی خود را تغییر دهید",
            "warning",
            2000,
          );
          this.config.pagination = false;
          this.rows = [];
          this.loadingRender = false;
        }
      });
    },
    GetItemCardMeli(data) {
      var dataAxios = {
        Method: "POST",
        Action: "Uploader/GetFile",
        ArryfildValue: {
          MasterId: data,
          tableName: "wwwNewtblAzaForEftetahHesab",
          grp328: 181070514,
        },
      };
      this.$PostData(dataAxios).then((result) => {
        // console.log(result);
        this.file = result.data;
        if (result.data == null || result.data.length == 0) {
        } else {
          this.Files = result.data;
          var fileLink = document.createElement("a");
          fileLink.download = this.Files[0].filename;
          fileLink.href =
            "data:application/octet-stream;base64," + this.Files[0].binary;
          document.body.appendChild(fileLink);
          fileLink.target = "_blank";
          fileLink.click();
        }
      });
    },
    GetItemShenasname(data) {
      var dataAxios = {
        Method: "POST",
        Action: "Uploader/GetFile",
        ArryfildValue: {
          MasterId: data,
          tableName: "wwwNewtblAzaForEftetahHesab",
          grp328: 181070505,
        },
      };
      this.$PostData(dataAxios).then((result) => {
        // console.log(result);
        this.file = result.data;
        if (result.data == null || result.data.length == 0) {
        } else {
          this.Files = result.data;
          var fileLink = document.createElement("a");
          fileLink.download = this.Files[0].filename;
          fileLink.href =
            "data:application/octet-stream;base64," + this.Files[0].binary;
          document.body.appendChild(fileLink);
          fileLink.target = "_blank";
          fileLink.click();
        }
      });
    },
    GetItemHokm(data) {
      var dataAxios = {
        Method: "POST",
        Action: "Uploader/GetFile",
        ArryfildValue: {
          MasterId: data,
          tableName: "wwwNewtblAzaForEftetahHesab",
          grp328: 181070516,
        },
      };
      this.$PostData(dataAxios).then((result) => {
        // console.log(result);
        this.file = result.data;
        if (result.data == null || result.data.length == 0) {
        } else {
          this.Files = result.data;
          var fileLink = document.createElement("a");
          fileLink.download = this.Files[0].filename;
          fileLink.href =
            "data:application/octet-stream;base64," + this.Files[0].binary;
          document.body.appendChild(fileLink);
          fileLink.target = "_blank";
          fileLink.click();
        }
      });
    },
    GetFish(data) {
      var dataAxios = {
        Method: "POST",
        Action: "Uploader/GetFile",
        ArryfildValue: {
          MasterId: data,
          tableName: "wwwNewtblAzaForEftetahHesab",
          grp328: 181070524,
        },
      };
      this.$PostData(dataAxios).then((result) => {
        // console.log(result);
        this.file = result.data;
        if (result.data == null || result.data.length == 0) {
        } else {
          for (let index = 0; index < result.data.length; index++) {
            this.Files = result.data;
            var fileLink = document.createElement("a");
            fileLink.download = this.Files[index].filename;
            fileLink.href =
              "data:application/octet-stream;base64," +
              this.Files[index].binary;
            document.body.appendChild(fileLink);
            fileLink.target = "_blank";
            fileLink.click();
          }
        }
      });
    },
    Get3File(data) {
      var dataAxios = {
        Method: "POST",
        Action: "Uploader/GetFile",
        ArryfildValue: {
          MasterId: data,
          tableName: "wwwNewtblAzaForEftetahHesab",
          grp328: 181070517,
        },
      };
      this.$PostData(dataAxios).then((result) => {
        // console.log(result);
        this.file = result.data;
        if (result.data == null || result.data.length == 0) {
        } else {
          for (let index = 0; index < result.data.length; index++) {
            this.Files = result.data;
            var fileLink = document.createElement("a");
            fileLink.download = this.Files[index].filename;
            fileLink.href =
              "data:application/octet-stream;base64," +
              this.Files[index].binary;
            document.body.appendChild(fileLink);
            fileLink.target = "_blank";
            fileLink.click();
          }
        }
      });
    },
    removeRequest(row) {
      this.$SweetQustion(
        "حذف درخواست عضویت",
        "آیا از حذف درخواست عضویت " +
          row.row.nameFamily +
          " با شماره پرسنلی " +
          row.row.perNo +
          " اطمینان دارید؟ درصورت حذف اطلاعات به هیچ عنوان قابل بازگشت نمی باشد",
        "warning",
        "حذف",
        "انصراف",
        row.row,
        this.acceptRemove,
        this.CancelDelete,
      );
    },
    acceptRemove(row) {
      // console.log(row)
      this.loadingRender = true;
      const formData = new FormData();
      formData.append("id", row.id);
      let DataAxios_Remove = {
        ArryfildValue: formData,
        Method: "Post",
        Action: "InsNewAza/Delete",
        Token: this.$session.get("TokenNetPa"),
      };
      let icon = "";
      this.$PostFormData(DataAxios_Remove).then((res) => {
        // console.log('🤦🏻‍♂️ ~ file: ListRegisterRequests.vue:455 ~ res:', res)
        this.loadingRender = false;
        if (res.status == true) {
          this.GetData();
          icon = "success";
        } else {
          icon = "error";
        }
        this.$mySweetDefaultTost("حذف موفق", res.message, icon, 4000);
      });
    },
  },
  mounted() {
    this.GetData();
  },
};
</script>
<style scoped>
.list-register-requests-filters {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: flex-start;
  gap: 0.75rem;
  width: 100%;
  margin: 0 0 1rem;
  padding: 0 0 1rem;
  border-bottom: 1px solid #e8eef2;
}

.list-register-requests-field {
  display: flex;
  flex: 0 1 11.5rem;
  flex-direction: column;
  min-width: 10rem;
  text-align: right;
}

.list-register-requests-action {
  flex: 0 0 auto;
  min-width: 0;
}

.list-register-requests-label {
  display: block;
  margin-bottom: 0.35rem;
  min-height: 1.25rem;
  color: #29345f;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px !important;
  font-weight: 700;
  line-height: 1.25rem;
}

.list-register-requests-label--spacer {
  visibility: hidden;
  user-select: none;
}

.list-register-requests-field >>> .vpd-main {
  display: block;
  width: 100%;
}

.list-register-requests-field >>> .vpd-input-group {
  display: flex;
  align-items: stretch;
  width: 100%;
  min-height: 40px;
  overflow: hidden;
  border: 1px solid #dbe5eb;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 1px 3px rgba(41, 52, 95, 0.06);
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.list-register-requests-field >>> .vpd-input-group:focus-within {
  border-color: #287db4;
  box-shadow: 0 0 0 3px rgba(5, 184, 200, 0.2);
}

.list-register-requests-field >>> .vpd-input-group input,
.list-register-requests-field >>> .vpd-input-group input.form-control {
  width: 100%;
  min-width: 0;
  height: 40px;
  min-height: 40px;
  margin: 0;
  padding: 0.4rem 0.75rem;
  border: none !important;
  border-radius: 0 !important;
  background: transparent;
  box-shadow: none !important;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px;
}

.list-register-requests-field >>> .vpd-input-group .vpd-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 2.4rem;
  margin: 0 !important;
  padding: 0 0.6rem !important;
  color: #287db4;
  border: none;
  background: #edf5fb;
}

.list-register-requests-search-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 6.75rem;
  min-height: 40px;
  height: 40px;
  margin: 0;
  padding: 0 1rem;
  border-radius: 12px;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px;
  font-weight: 700;
}

.list-register-requests-cards {
  display: none;
}

.list-register-requests-cards__toolbar {
  margin: 0 0 0.85rem;
}

.list-register-requests-cards__search {
  width: 100%;
  min-height: 40px;
  padding: 0.45rem 0.75rem;
  color: #13243a;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px;
  font-weight: 500;
  border: 1px solid #dce1e8;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 1px 3px rgba(42, 63, 84, 0.06);
}

.list-register-requests-cards__search:focus {
  border-color: #287db4;
  box-shadow: 0 0 0 3px rgba(5, 184, 200, 0.2);
  outline: none;
}

.list-register-requests-cards__empty {
  margin: 0.75rem 0 0;
  padding: 1.5rem 1rem;
  color: #6b7b8e;
  font-size: 13px;
  font-weight: 700;
  text-align: center;
  border: 1px dashed #dbe5eb;
  border-radius: 14px;
  background: #f8fafc;
}

.list-register-requests-cards__list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.list-register-requests-card {
  padding: 0.95rem 1rem 0.9rem;
  border: 1px solid #e8eef2;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 8px 22px rgba(41, 52, 95, 0.06);
}

.list-register-requests-card__header {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.5rem 0.75rem;
  margin-bottom: 0.7rem;
}

.list-register-requests-card__name {
  min-width: 0;
  color: #13243a;
  font-size: 14px;
  font-weight: 800;
  line-height: 1.45;
}

.list-register-requests-card__badge {
  display: inline-flex;
  align-items: center;
  min-height: 26px;
  padding: 0.15rem 0.65rem;
  border-radius: 999px;
  color: #287db4;
  background: #edf5fb;
  font-size: 12px;
  font-weight: 800;
}

.list-register-requests-card__fields {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
  margin-bottom: 0.75rem;
}

.list-register-requests-card__fields--more {
  margin-top: -0.25rem;
  padding-top: 0.65rem;
  border-top: 1px solid #e8eef2;
}

.list-register-requests-card__field {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.75rem;
}

.list-register-requests-card__field span {
  flex-shrink: 0;
  color: #6b7b8e;
  font-size: 12px;
  font-weight: 700;
}

.list-register-requests-card__field strong {
  min-width: 0;
  color: #13243a;
  font-size: 13px;
  font-weight: 700;
  text-align: left;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.list-register-requests-card__actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.45rem;
}

.list-register-requests-card__actions .list-register-requests-row-actions {
  display: flex;
  flex-wrap: wrap;
  flex: 1 1 100%;
  justify-content: flex-start;
  gap: 0.45rem;
}

.list-register-requests-card__actions .list-register-requests-row-btn {
  flex: 1 1 5.5rem;
}

.list-register-requests-cards__pager {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  margin-top: 0.85rem;
}

.list-register-requests-cards__pager-btn {
  min-height: 34px;
  padding: 0.3rem 0.85rem;
  color: #29345f;
  border: 1px solid #dbe5eb;
  border-radius: 10px;
  background: #fff;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}

.list-register-requests-cards__pager-btn:disabled {
  opacity: 0.45;
  cursor: default;
}

.list-register-requests-cards__pager-info {
  color: #6b7b8e;
  font-size: 12px;
  font-weight: 700;
}

@media (max-width: 767px) {
  .list-register-requests-field,
  .list-register-requests-action {
    flex: 1 1 100%;
    min-width: 0;
  }

  .list-register-requests-search-btn {
    width: 100%;
  }

  .list-register-requests-cards {
    display: block;
  }

  .list-register-requests-table-view {
    display: none;
  }

}

>>> .list-register-requests-action-cell {
  min-width: 16rem;
  vertical-align: middle !important;
}

.list-register-requests-row-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
  gap: 0.35rem;
  width: 100%;
}

.list-register-requests-row-actions:has(> :only-child) {
  justify-content: center;
}

.list-register-requests-row-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  min-height: 34px;
  margin: 0;
  padding: 0.3rem 0.75rem;
  border: 1px solid;
  border-radius: 10px;
  box-shadow: 0 1px 2px rgba(41, 52, 95, 0.05);
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.2;
  white-space: nowrap;
  cursor: pointer;
  text-decoration: none;
  transition: background-color 0.15s ease, border-color 0.15s ease,
    color 0.15s ease, box-shadow 0.15s ease;
}

.list-register-requests-row-btn i {
  font-size: 11px;
}

.list-register-requests-row-btn:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(5, 184, 200, 0.2);
}

.list-register-requests-row-btn.dropdown-toggle::after {
  margin-right: 0.2rem;
  margin-left: 0;
  vertical-align: 0.15em;
}

.list-register-requests-row-btn--details {
  color: #29345f;
  border-color: #dbe5eb;
  background: #fff;
}

.list-register-requests-row-btn--details:hover,
.list-register-requests-row-btn--details:focus {
  color: #8d58a4;
  border-color: rgba(141, 88, 164, 0.28);
  background: rgba(141, 88, 164, 0.05);
}

.list-register-requests-row-btn--attach {
  color: #287db4;
  border-color: #cfe4f2;
  background: #edf5fb;
}

.list-register-requests-row-btn--attach:hover,
.list-register-requests-row-btn--attach:focus,
.list-register-requests-row-actions .dropdown.show .list-register-requests-row-btn--attach {
  color: #fff;
  border-color: #287db4;
  background: #287db4;
}

.list-register-requests-row-btn--edit {
  color: #8a6414;
  border-color: #eed9b0;
  background: #fff4d6;
}

.list-register-requests-row-btn--edit:hover,
.list-register-requests-row-btn--edit:focus {
  color: #fff;
  border-color: #c48726;
  background: #c48726;
}

.list-register-requests-row-btn--approve {
  color: #2f7a1f;
  border-color: #b7dfb0;
  background: #eef8ec;
}

.list-register-requests-row-btn--approve:hover,
.list-register-requests-row-btn--approve:focus {
  color: #fff;
  border-color: #2f7a1f;
  background: #2f7a1f;
}

.list-register-requests-row-btn--receipt,
.list-register-requests-row-btn--sms {
  color: #068997;
  border-color: #c5e8ec;
  background: #e9f9fb;
}

.list-register-requests-row-btn--receipt:hover,
.list-register-requests-row-btn--receipt:focus,
.list-register-requests-row-btn--sms:hover,
.list-register-requests-row-btn--sms:focus {
  color: #fff;
  border-color: #068997;
  background: #068997;
}

.list-register-requests-row-btn--delete {
  color: #b44f46;
  border-color: #f0d4d1;
  background: #fcefed;
}

.list-register-requests-row-btn--delete:hover,
.list-register-requests-row-btn--delete:focus {
  color: #fff;
  border-color: #b44f46;
  background: #b44f46;
}

.list-register-requests-attach-menu {
  min-width: 14.5rem;
  padding: 0.4rem 0;
  margin: 0.35rem 0 0;
  border: 1px solid #e8eef2;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(42, 63, 84, 0.12);
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  text-align: right;
}

.list-register-requests-attach-menu .dropdown-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.45rem 0.85rem;
  color: #29345f;
  font-size: 12px;
  font-weight: 600;
}

.list-register-requests-attach-menu .dropdown-item i {
  width: 1rem;
  color: #287db4;
  font-size: 12px;
  text-align: center;
}

.list-register-requests-attach-menu .dropdown-item:hover,
.list-register-requests-attach-menu .dropdown-item:focus {
  color: #1f6a9c;
  background: #edf5fb;
}
</style>
